import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      openAction: 'Импорт',
      title: 'EAN инфо импорт',
      executeAction: 'Отправить',
      errorMessage: 'Ошибка',
      successMessage: 'Все %{count} строки добавлены',
      addedItemsCount: 'Добавлено строк',
      errorItems: 'Ошибки',
      fields: {
      },
    }
  }
}